import React from 'react'
// import Nav from 'react-bootstrap/Nav'
// import { Link } from 'react-router-dom'
import './AboutPage.css'


const AboutPage = () => (
  <div className='aboutPage'>
    <br></br>
    <h2>Pecunia ™️</h2>
    <br></br>
    <h3>Brought to you by <br></br>
      © Mayday Media 2022</h3>
  </div>
)

export default AboutPage